module.exports = __webpack_public_path__ + "static/img/epidemic-2.825d05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-2.png
// module id = iE0x
// module chunks = 1